import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const BookOfBusinessSection = ({
  theme,
  businessRows,
  healthOptions,
  getRowHealthValue,
  onHealthChange,
  aumDistributions,
  AumDonut,
}) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: "0 8px 20px rgba(15,23,42,0.06)" }}>
      <CardContent>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Tooltip
            title="Snapshot of all current mandates, buy ratings, health signals and vehicles for this client."
            arrow
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                cursor: "help",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Book of Business
            </Typography>
          </Tooltip>
          <DataSourceIcon mode="light" sources={["Salesforce"]} />
        </Box>

        <Box sx={{ display: "flex", gap: 3, mb: 2, fontSize: "0.85rem" }}>
          <span>🟢 Healthy</span>
          <span>🟡 Caution</span>
          <span>🔴 At Risk</span>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            alignItems: "stretch",
          }}
        >
          <Box sx={{ flex: 3, minWidth: 0, overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  {[
                    "Asset Class",
                    "Strategy",
                    "Buy Rating",
                    "Health",
                    "Vehicle",
                    "AUM",
                  ].map((h) => (
                    <TableCell
                      key={h}
                      sx={{
                        bgcolor: theme.palette.primary.main,
                        color: "#fff",
                        fontWeight: 600,
                      }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {businessRows.map((row) => {
                  const currentHealth = getRowHealthValue(row.strategy);

                  return (
                    <TableRow key={row.strategy}>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {row.assetClass}
                      </TableCell>
                      <TableCell>{row.strategy}</TableCell>
                      <TableCell>{row.rating}</TableCell>
                      <TableCell>
                        <Select
                          size="small"
                          value={currentHealth}
                          onChange={(e) =>
                            onHealthChange(row.strategy, e.target.value)
                          }
                          sx={{
                            fontSize: "0.85rem",
                            "& .MuiSelect-select": {
                              py: 0.5,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            },
                          }}
                        >
                          {healthOptions.map((opt) => (
                            <MenuItem
                              key={opt.value}
                              value={opt.value}
                              sx={{ fontSize: "0.85rem" }}
                            >
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell>{row.vehicle}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.aum}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>

          <AumDonut aumDistributions={aumDistributions} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default BookOfBusinessSection;
